/** Status pill for leaks. */
import { useTranslation } from "react-i18next";
import { STATUS_COLORS, STATUS_KEYS } from "../../api/leaks";

export default function LeakStatusBadge({ status, className = "" }) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={`leak-status-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${STATUS_COLORS[status] || "bg-slate-100 text-slate-700"} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-60" />
      {t(STATUS_KEYS[status] || status)}
    </span>
  );
}
